import { useEffect, MutableRefObject } from 'react';

export const useOutsideClickHandler = (
  ref: MutableRefObject<HTMLElement | null>,
  onClickOutside: () => void,
) => {
  useEffect(() => {
    function handleClickOutside(event: globalThis.MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onClickOutside();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClickOutside, ref]);
};
